import { render, staticRenderFns } from "./RootsAndDegreesForm.vue?vue&type=template&id=3a82fe3a&scoped=true&lang=pug&"
import script from "./RootsAndDegreesForm.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegreesForm.vue?vue&type=script&lang=js&"
import style0 from "./RootsAndDegreesForm.vue?vue&type=style&index=0&id=3a82fe3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82fe3a",
  null
  
)

export default component.exports